'use client';

import type { Opportunity } from '@/modules/Customer/http/client/mutations/useCreateSFOpportunity';

export const openChatWithOpportunity = (fields: ChatOpportunity) => {
  if (typeof window !== 'undefined') {
    window.embeddedservice_bootstrap?.prechatAPI.setHiddenPrechatFields(fields);
    window.embeddedservice_bootstrap?.utilAPI.launchChat();
  }
};

export const openChatWithoutQuestionOpportunity = () => {
  if (typeof window !== 'undefined') {
    window.embeddedservice_bootstrap?.utilAPI.launchChat();
  }
};

type ChatOpportunity = Omit<Opportunity, 'description'> & {
  [question: `questionAndAnswer${number}`]: string;
};
